@let view = data();

@if (view.headlines) {
  <ui-headlines [data]="view.headlines" [level]="3"></ui-headlines>
}

<ui-accordion [class.with-headlines]="view.headlines">
  @for (item of view.items; track item) {
    <ng-template
      uiAccordionPanel
      [headline]="item.headline"
      [icon]="item.icon"
      [iconStyle]="item.iconStyle"
    >
      <div [innerHTML]="item.content" uiHtmlDataLink></div>
    </ng-template>
  }
</ui-accordion>
